var HeaderNav = (function($) {

	var $sticky = $('.masthead__sticky');

	var $top 	  = $('.masthead__top'),
		$topNav   = $('.masthead__nav'),
		$topItems = $topNav.find('.menu > li > a');

	var $bottom      = $('.masthead__bottom'),
		$bottomNav   = $('.masthead__entity-nav'),
		$bottomLabel = $bottomNav.find('> span'),
		$bottomMenu  = $bottomNav.find('> .menu');

	var init = function() {
		MobileMenu.init();

		// Top section
		$topItems.click(function(e) {
			var $topItem = $(this);
			var $subMenu = $topItem.siblings('.sub-menu');

			if ( ! $subMenu.length) {
				return;
			}

			$topItem.toggleClass('active');
			$subMenu.toggle();

			// Close opened sub menu's
			$('.sub-menu').not($subMenu).filter(':visible')
				.hide()
				.siblings('a')
				.removeClass('active');

			e.preventDefault();
		});

		$topNav.find('.menu-item-has-children .sub-menu').each(function() {
			var childrenCount = $(this).children().length;

			$(this).css({"column-count" : Math.min(Math.ceil(childrenCount/6), 2)});
		});

		// sticky masthead
		$sticky.sticky({
			context: '#page'
		});

		// Bottom section
		$bottomLabel.click(function() {
			$bottomMenu.slideToggle(250);
		});

		var $activeItem = $bottomMenu.find('.current-menu-item');
		if ($activeItem.length) {
			$bottomLabel.text($activeItem.text());
		}
	};

	/**
	 * Mobile menu component
	 */
	var MobileMenu = {
		mmenu: '',
		menuElem: $('#mobile-menu'),

		init: function() {
			if( this.menuElem.length > 0 ) {
				this.mmenu = this.menuElem.mmenu({
					// "offCanvas": {
					// 	"position": "right",
					// 	"zposition": "front"
					// }
				});
				this.events();
			}
		},

		events: function() {
			var self = this;
			var api = this.mmenu.data('mmenu');

			api
				.bind('opened', self.toggleHamburger.bind(this))
				.bind('closed', self.toggleHamburger.bind(this));
		},

		toggleHamburger: function() {
			$( '#hamburger-mobile-menu' ).toggleClass( 'is-active' );

			this.menuElem.attr('aria-hidden', function (i, attr) {
				return attr === 'true' ? 'false' : 'true'
			});
		}
	};

	return {
		init: init
	}

})(jQuery);

